<template>
  <div>
    <v-data-table
      :items="items"
      :headers="headers"
      :server-items-length="count"
      :options="pagination"
      :loading="loading"
      @update:page="move"
      :footer-props="{
        'disable-items-per-page': true,
        'items-per-page-options': []
      }"
    >
      <template v-slot:item.packet="{ item }">
        {{ toHexString(item.packet.data) }}
      </template>
    </v-data-table>

    <v-divider></v-divider>
  </div>
</template>

<script>
import { getPacketErrors } from '@/api'
import { getPaginationParams } from '@/utils'

export default {
  data () {
    return {
      packets: [],
      count: 0,
      loading: false,
      headers: [
        {
          text: 'deviceType',
          value: 'deviceType'
        },
        {
          text: 'identityNo',
          value: 'identityNo'
        },
        {
          text: 'command',
          value: 'command'
        },
        {
          text: 'message',
          value: 'message'
        },
        {
          text: 'date',
          value: 'createdAt'
        },
        {
          text: 'packet',
          value: 'packet'
        }
      ],
      pagination: {
        page: 1,
        itemsPerPage: 30
      }
    }
  },
  computed: {
    items () {
      return this.packets
    }
  },
  async beforeRouteEnter (to, from, next) {
    let page = parseInt(to.query.page, 10) || 1
    if (page < 1) page = 1

    const params = getPaginationParams(to)
    try {
      const { items, count } = await getPacketErrors(params)

      console.log(items[0])

      next(vm => {
        vm.packets = items
        vm.count = count
        vm.pagination.page = page
      })
    } catch (err) {
      next()
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      await this.fetch(to)
      next()
    } catch (err) {
      next()
    } finally {
      this.loading = false
    }
  },
  methods: {
    async fetch (route) {
      this.loading = true
      const params = getPaginationParams(route)

      try {
        const { items, count } = await getPacketErrors(params)

        this.packets = items
        this.count = count
      } finally {
        this.loading = false
      }
    },
    move (page) {
      if (page !== this.pagination.page) {
        this.pagination.page = page
        this.$router.push({ query: { page } })
      }
    },
    toHexString (arr) {
      const hexes = arr.map(int => int.toString(16).toUpperCase().padStart(2, '0'))

      if (hexes.length > 16) {
        return hexes.slice(0, 16).join(' ') + ' ... ' + `${hexes.length - 16} more packets`
      } else {
        hexes.join(' ')
      }
    }
  }
}
</script>
